export { default as config } from './WebIMConfig';
export { default as WebIM } from './WebIM';
